module.exports = __webpack_public_path__ + "static/media/marketing_campaign.501409b8.jpg";